import React, { useEffect, useState } from "react";
import LanguageMenu from "../Components/LanguageMenu";
import { useNavigate } from "react-router-dom";
import IFIX from "./Images/IFIX GREEN.png";

function NavBar() {
  const navigate = useNavigate();
  const [menu, setMenu] = useState(false);
  const [clickContact, setClickContact] = useState(false);
  const [selectedPage, setSelectedPage] = useState(
    sessionStorage.getItem("selectedItem") || "Home",
  );

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        document.getElementById("nav").classList.add("fixed", "shadow-lg");
      } else {
        document.getElementById("nav").classList.remove("fixed", "shadow-lg");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const selectPage = (e) => {
    const item = e.target.textContent;
    setSelectedPage(item);
    sessionStorage.setItem("selectedItem", item);
    if (item === "Home") {
      navigate("/");
    } else {
      navigate(`/${item}`);
    }
  };

  const navigateContact = async () => {
    try {
      navigate("/ICraft");
      setSelectedPage("ICraft");
      sessionStorage.setItem("selectedItem", "ICraft");
      setTimeout(() => {
        const ref = document.getElementById("section2");
        if (ref) {
          ref.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    } catch (error) {
      console.error("Error in navigateContact:", error);
    }
  };
  return (
    <nav
      id="nav"
      className="w-screen bg-white flex flex-col lg:flex-row lg:items-center px-5 lg:px-[62px] py-4 lg:justify-between gap-8 z-50"
    >
      <div className={`w-full lg:w-auto flex items-center justify-between`}>
        <img loading="lazy" src={IFIX} className="max-w-full w-[20%] h-[30%]" />
        <button onClick={() => setMenu(!menu)} className="flex lg:hidden">
          {menu ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32px"
              height="32px"
              viewBox="0 0 24 24"
            >
              <path
                fill="black"
                d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"
              ></path>
            </svg>
          ) : (
            <svg
              className="flex lg:hidden"
              xmlns="http://www.w3.org/2000/svg"
              width="32px"
              height="32px"
              viewBox="0 0 24 24"
            >
              <path
                fill="black"
                d="M7 8h14c.6 0 1-.4 1-1s-.4-1-1-1H7c-.6 0-1 .4-1 1s.4 1 1 1m14 3H7c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1m0 5H7c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1M3.7 6.3c-.1-.1-.2-.2-.3-.2c-.4-.2-.8-.1-1.1.2c-.1.1-.2.2-.2.3c-.1.3-.1.5 0 .8c.1.1.1.2.2.3c.1.1.2.2.3.2c.1.1.3.1.4.1c.3 0 .5-.1.7-.3c.1-.1.2-.2.2-.3c.1-.3.1-.5 0-.8c0-.1-.1-.2-.2-.3m0 5c-.3-.3-.7-.4-1.1-.2c-.1.1-.2.1-.3.2c-.1.1-.2.2-.2.3c-.1.2-.1.5 0 .8c.1.1.1.2.2.3c.1.1.2.2.3.2c.1.1.3.1.4.1c.1 0 .3 0 .4-.1c.1-.1.2-.1.3-.2c.1-.1.2-.2.2-.3c.1-.2.1-.5 0-.8c0-.1-.1-.2-.2-.3m0 5c-.1-.1-.2-.2-.3-.2c-.2-.1-.5-.1-.8 0c-.1 0-.2.1-.3.2c-.1.1-.2.2-.2.3c-.2.4-.1.8.2 1.1c.1.1.2.2.3.2c.1.1.3.1.4.1c.1 0 .3 0 .4-.1c.1-.1.2-.1.3-.2c.3-.3.4-.7.2-1.1c0-.1-.1-.2-.2-.3"
              ></path>
            </svg>
          )}
        </button>
      </div>
      <div
        className={`${
          menu ? "flex" : "hidden lg:flex"
        } gap-8 flex-col lg:flex-row capitalize text-[18px]`}
      >
        <button
          onClick={selectPage}
          className={`${selectedPage === "Home" && "font-bold"}`}
        >
          Home
        </button>
        <button
          onClick={selectPage}
          className={`${selectedPage === "IFix" && "font-bold"}`}
        >
          IFix
        </button>
        <button
          onClick={selectPage}
          className={`${selectedPage === "ICraft" && "font-bold"}`}
        >
          ICraft
        </button>
        <button
          onClick={selectPage}
          className={`${selectedPage === "IGreen" && "font-bold"}`}
        >
          IGreen
        </button>
        <button
          onClick={selectPage}
          className={`${selectedPage === "IAutomate" && "font-bold"}`}
        >
          IAutomate
        </button>
      </div>
      <div className={`${menu ? "" : "hidden lg:flex"} items-center gap-8`}>
        <button
          className="px-4 py-3 capitalize hover:bg-blue-800 rounded-2xl text-white font-bold text-[18px] bg-[#36689E]"
          onClick={navigateContact}
        >
          contact us
        </button>
        <LanguageMenu />
      </div>
    </nav>
  );
}

export default NavBar;
